import PropTypes from 'prop-types';
import React from 'react';
import { Collapse } from 'react-bootstrap';

import { trackEvent, togglePackageOptionsEvent } from '../utils/analytics';

export default class SinglePackage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false
		};
		this.renderOptions = this.renderOptions.bind(this);
		this.toggleOptions = this.toggleOptions.bind(this);
	}
	toggleOptions() {
		const { windowId, widgetName } = this.props.widgetInfo;
		this.setState({ open: !this.state.open }, () => {
			trackEvent(togglePackageOptionsEvent(widgetName, windowId));
		});
	}
	renderOptions(options = [], indentStyles = '', hasLink = false) {
		const linkVisibility = this.state.open ? 'hidden' : '';
		const collapseLink = hasLink ? (
			<li className={`${linkVisibility}`}>
				<button
					key="button"
					type="button"
					onClick={this.toggleOptions}
					className="text-link"
				>
					Show All Package Items
				</button>
			</li>
		) : null;
		return (
			<ul
				className={`text-muted list-unstyled list-spaced ${indentStyles}`}
			>
				{options.map(item => (
					<li key={item}>{item}</li>
				))}
				{collapseLink}
			</ul>
		);
	}
	render() {
		const {
			deviceType,
			idx,
			packageName,
			packageOptions,
			packagePrice,
			showPricing
		} = this.props;

		if (idx === undefined || !packageName) {
			return null;
		}
		const indentStyles = deviceType === 'DESKTOP' ? 'ml-6' : '';
		const packageTitleMargin = idx === 0 ? 'mb-4' : 'my-4';

		const displayPrice =
			packagePrice !== '0' ? (
				<span className="ml-auto pl-5 package-price">{`${packagePrice}`}</span>
			) : null;

		// if price doesn't exist, make name column full width so as to not wrap early
		let renderedOptions;
		let additionalOptions;

		if (packageOptions.length === 0) {
			// do nothing
		} else if (packageOptions.length < 5) {
			// render all options if 4 or less
			renderedOptions = this.renderOptions(packageOptions, indentStyles);
		} else {
			// render first 3 options and have link to show the rest
			const firstThreeOptions = packageOptions.slice(0, 3);
			const remaindingOptions = packageOptions.slice(3);
			renderedOptions = this.renderOptions(
				firstThreeOptions,
				indentStyles,
				true
			);
			const renderedRemaindingOptions = this.renderOptions(
				remaindingOptions,
				indentStyles
			);
			additionalOptions = [
				<Collapse key="collapse" in={this.state.open}>
					{renderedRemaindingOptions}
				</Collapse>
			];
		}
		return (
			<div>
				<strong className={`${packageTitleMargin} d-flex`}>
					<span className="package-title">{packageName}</span>
					{showPricing ? displayPrice : null}
				</strong>
				{renderedOptions}
				{additionalOptions}
			</div>
		);
	}
}

SinglePackage.defaultProps = {
	idx: undefined,
	packageName: undefined,
	packageOptions: [],
	packagePrice: '0',
	widgetInfo: {
		windowId: 'packages-options1',
		widgetName: 'ws-packages-options'
	}
};

SinglePackage.propTypes = {
	deviceType: PropTypes.string.isRequired,
	idx: PropTypes.number,
	packageName: PropTypes.string,
	packageOptions: PropTypes.arrayOf(PropTypes.string.isRequired),
	packagePrice: PropTypes.string,
	showPricing: PropTypes.bool.isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string,
		widgetName: PropTypes.string
	})
};



// WEBPACK FOOTER //
// ./src/components/SinglePackage.jsx